import { render, staticRenderFns } from "./loveThreeMatchList.vue?vue&type=template&id=29ced321&scoped=true"
import script from "./loveThreeMatchList.vue?vue&type=script&lang=js"
export * from "./loveThreeMatchList.vue?vue&type=script&lang=js"
import style0 from "./loveThreeMatchList.vue?vue&type=style&index=0&id=29ced321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ced321",
  null
  
)

export default component.exports